import { Component, Input, OnInit } from '@angular/core';
import { LetterheadService } from '../letterhead.service';
import { Letterhead } from '../letterhead';
import { NotificationService } from '../../shared/notification.service';
import { SelectComparisons } from '../../shared/pipes/select.comparisons';

@Component({
  selector: 'app-letterhead-select',
  templateUrl: 'select.component.html',
})
export class LetterheadSelectComponent extends SelectComparisons
  implements OnInit {
  /**
   * The model that we will be adding the letterhead to.
   */
  @Input() model: any;

  /**
   * Do we require this field in the main form it is
   * included in?
   */
  @Input() required: boolean;

  /**
   * A list of all the letterheads currently loaded.
   *
   * @type {Letterhead[]}
   */
  public letterheads: Letterhead[] = [];

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = true;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {LetterheadService} letterheadService
   * @param {NotificationService} notificationService
   */
  constructor(
    private letterheadService: LetterheadService,
    private notificationService: NotificationService,
  ) {
    super();
    this.letterheadService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  /**
   * When the component is initialised we set it to load
   * page one of the letterhead list.
   */
  public ngOnInit(): void {
    this.loadLetterheads(1, 10000);
  }

  /**
   * Loads a list of letterheads using the given per page limit.
   *
   * @param {number} page The current page we require.
   * @param {number} limit The number of results per page.
   */
  public loadLetterheads(page?: number, limit?: number): void {
    const listLetterheads = this.letterheadService
      .listLetterheads(page, limit)
      .subscribe((letterheads: Letterhead[]) => {
        this.letterheads = letterheads;
        listLetterheads.unsubscribe();
      });
  }
}
